function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100%",
  y1: "23.8144985%",
  x2: "0%",
  y2: "81.5452398%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D74119",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FA8C28",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Logo-variations",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "UserVoice-logomark"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logomark",
  transform: "translate(40.000000, 25.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M120,16.6999969 L95,0 L70,16.6999969 L70,104.9999 L90,104.9999 L90,26.3999939 L95,23.1000061 L100,26.3999939 L100,103.9999 C100,120.5839 95,137.2839 76,148.9999 C95.345,148.9999 119.437,127.2529 120,99.0129 L120,16.6999969 Z",
  id: "U-Right",
  fill: "#D74119"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5903504,128.879251 C27.4115989,125.714221 20,116.206322 20,105 L20,100 C20,95 15,90 15,85 C15,81.523 17.415,78.047 18.888,74.57 C19.594,73.2 20,71.648 20,70 C20,64.477 15.523,60 10,60 C4.478,60 0,64.477 0,70 C0,71.648 0.406,73.199 1.113,74.57 C2.585,78.046 5,81.523 5,85 C5,90 0,95 0,100 L0,105 C0,129.813 20.187,150 45,150 L49,140.167 L48.8291084,139.732636 C50.9764539,141.193746 53.2751757,142.508264 55.708,143.664 L63.791,128.1 C55.109,123.975 50,114.604 50,105 L50,100 C50,95 45,90 45,85 C45,81.523 47.415,78.047 48.888,74.57 C49.594,73.2 50,71.648 50,70 C50,64.477 45.523,60 40,60 C34.477,60 30,64.477 30,70 C30,71.648 30.406,73.199 31.112,74.57 C32.585,78.046 35,81.523 35,85 C35,90 30,95 30,100 L30,105 C30,114.01599 32.746141,122.128212 37.5903504,128.879251 Z M20,43 C20,37.477 15.523,33 10,33 C4.477,33 0,37.477 0,43 C0,48.523 4.477,53 10,53 C15.523,53 20,48.523 20,43 Z M20,16 C20,10.477 15.523,6 10,6 C4.477,6 0,10.477 0,16 C0,21.523 4.477,26 10,26 C15.523,26 20,21.523 20,16 Z M50,43 C50,37.477 45.523,33 40,33 C34.477,33 30,37.477 30,43 C30,48.523 34.477,53 40,53 C45.523,53 50,48.523 50,43 Z M50,16 C50,10.477 45.523,6 40,6 C34.477,6 30,10.477 30,16 C30,21.523 34.477,26 40,26 C45.523,26 50,21.523 50,16 Z",
  id: "U-Left",
  fill: "#FA8C28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45,130 C58.785,130 70,118.785 70,105 L70,43 L90,43 L90,105 C90,129.813 69.813,150 45,150 L45,130 Z",
  id: "U-Gradient",
  fill: "url(#linearGradient-1)"
}))));

function SvgUservoiceLogomark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UserVoice-logomark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUservoiceLogomark);
export default __webpack_public_path__ + "static/media/uservoice_logomark.6477050d.svg";
export { ForwardRef as ReactComponent };